import React, { createContext, useContext, useRef, useState } from 'react';

/**
 * Livekit Connection Context
 * Shares room connection across pages to prevent disconnects during navigation
 */
const LivekitConnectionContext = createContext(null);

export const useLivekitConnection = () => {
  const context = useContext(LivekitConnectionContext);
  if (!context) {
    throw new Error('useLivekitConnection must be used within LivekitConnectionProvider');
  }
  return context;
};

export const LivekitConnectionProvider = ({ children }) => {
  const roomRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [agentReady, setAgentReady] = useState(false);
  const urlRef = useRef(null);
  const tokenRef = useRef(null);

  const setRoom = (room) => {
    roomRef.current = room;
    setIsConnected(room?.isConnected || false);
  };

  const setCredentials = (url, token) => {
    urlRef.current = url;
    tokenRef.current = token;
  };

  const getRoom = () => roomRef.current;
  const getUrl = () => urlRef.current;
  const getToken = () => tokenRef.current;

  const clearConnection = () => {
    if (roomRef.current && roomRef.current.isConnected) {
      roomRef.current.disconnect();
    }
    roomRef.current = null;
    setIsConnected(false);
    setAgentReady(false);
    urlRef.current = null;
    tokenRef.current = null;
  };

  return (
    <LivekitConnectionContext.Provider
      value={{
        roomRef,
        isConnected,
        agentReady,
        setRoom,
        setCredentials,
        getRoom,
        getUrl,
        getToken,
        setAgentReady,
        clearConnection,
      }}
    >
      {children}
    </LivekitConnectionContext.Provider>
  );
};
